<tp-modal [dialogTitle]="'Invitation for ' + data.userEmail">
  <p>This invitation will grant {{ data.userEmail }} the following access:</p>
  <br/>
  <tp-properties-table class="dark" [title]="'Team Access'">
    <tp-properties-table-row [key]="data.team.name!">{{ data.accessLevel | accessLevel }}</tp-properties-table-row>
  </tp-properties-table>
  <tp-properties-table class="dark" [title]="'Space Access'">
    @for (spaceAccess of data.spaceAccess; track spaceAccess.space.uuid) {
      <tp-properties-table-row [key]="spaceAccess.space.name!">{{ spaceAccess.accessLevel | accessLevel }}</tp-properties-table-row>
    }
  </tp-properties-table>
</tp-modal>
